// This allows you to import Checkbox as a default or named export
export { Checkbox as default, Checkbox } from './checkbox';
export type { CheckboxProps } from './types';
